(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.hide();
  }
  
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  }

  let button = document.querySelector(".chat-button");

  if (button != null) {
    button.addEventListener("click", (event) => {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
      event.preventDefault();
    });
  }
})();

// Delivery estimate app (delm-widget) on product pages. Its text is inside a shadow root, so
// custom.css can't reach it. Match the Trust Icons text: step names bold in the heading color,
// dates and the note in the grey second-line color. Below 769px the app's own sizes stay.
(function() {
  if (!window.customElements || !window.CSSStyleSheet || !('adoptedStyleSheets' in Document.prototype)) return;

  const css = `
    :host .delm-widget .text-container .title { color: #091115; font-weight: 700; }
    :host .delm-widget .text-container .date { color: #66625d; font-weight: 400; }
    :host .delm-widget .shipping-note { color: #66625d; }
    @media (min-width: 769px) {
      :host .delm-widget .text-container .title { font-size: 15px; }
      :host .delm-widget .text-container .date { font-size: 15px; }
      :host .delm-widget .shipping-note { font-size: 13px; }
    }
  `;
  let sheet = null;

  function styleWidget(widget, tries) {
    const root = widget.shadowRoot;
    if (!root) {
      if (tries < 40) setTimeout(() => styleWidget(widget, tries + 1), 250);
      return;
    }
    if (!sheet) {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
    }
    if (!root.adoptedStyleSheets.includes(sheet)) {
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    }
  }

  customElements.whenDefined('delm-widget').then(() => {
    document.querySelectorAll('delm-widget').forEach((widget) => styleWidget(widget, 0));
  });
})();
// Product description spec tables: keep each cell's last two words together with a non-breaking space, so a cell
// never ends with one word alone on its own line (Bill's no-orphan rule). The descriptions' own joins skip tables,
// and below 1024px custom.css lets the cells wrap. A line break (<br>, a new paragraph) before the last word stops
// the join, and a cell that is already joined is left alone.
(function() {
  var BREAKS = /^(BR|P|DIV|LI|UL|OL|H[1-6])$/;

  function isSpace(c) {
    return c === ' ' || c === '\n' || c === '\t' || c === '\r';
  }

  function joinLastWords(cell) {
    var seq = [];
    var walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) seq.push(node);
      else if (BREAKS.test(node.tagName)) seq.push(null);
    }

    var inLastWord = false;
    for (var i = seq.length - 1; i >= 0; i--) {
      if (seq[i] === null) {
        if (inLastWord) return;
        continue;
      }
      var text = seq[i].data;
      for (var j = text.length - 1; j >= 0; j--) {
        var c = text[j];
        if (!inLastWord) {
          if (!isSpace(c) && c !== ' ') inLastWord = true;
        } else if (c === ' ') {
          return;
        } else if (isSpace(c)) {
          var k = j;
          while (k > 0 && isSpace(text[k - 1])) k--;
          var wordBefore = text.slice(0, k).trim() !== '';
          for (var x = i - 1; !wordBefore && x >= 0 && seq[x] !== null; x--) wordBefore = seq[x].data.trim() !== '';
          if (wordBefore) seq[i].data = text.slice(0, k) + ' ' + text.slice(j + 1);
          return;
        }
      }
    }
  }

  document.querySelectorAll('.product-description.rte table td, .product-description.rte table th').forEach(joinLastWords);
})();
